import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appDoubleClick]',
})
export class DoubleClickDirective {
  @Output() dblClick: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  @HostListener('dblclick') onDoubleClicked() {
    this.dblClick.emit(true);
  }
}
